<template>
<div class="chapter">
<div class="inner_page">
<h1 class="center" id="chap6"><a id="page22">REAGAN, BEGIN, AND GOD</a></h1><a id="page22">
<p class="noind" style="margin-top:30px;">D<span class="small">ON’T GET ME WRONG</span>, I think the world of God. But it seems to me that He is too much with us lately, <i>in a certain form</i>. Israel’s Menachem Begin is wooing hardcore religionists for a coalition government. America’s (oh, come on) Ronald Reagan is being praised for statesmanship because his first Supreme Court nominee doesn’t quite please that luminous Christian, Jerry Falwell. (Strom Thurmond likes her, though. Great!) And both Begin and Reagan have been rather cavalier—<i>in my view—</i>about the risk of blowing things to perdition. I wonder—<i>I know, it’s none of my business, I don’t tithe—</i>whether the Judeo-Christian ethic is … in ideal hands.</p>
<p class="ind">With this thought in mind, and with apologies to Eugene Field, who anyway is dead, I have dashed off—which accounts for any infelicities—the following verses.</p>
<p class="poem3" style="margin-top:20px;"><i>Reagan, Begin, and God one night</i></p>
<p class="poem3"><i>Sailed a trilateral ship</i></p>
<p class="poem3"><i>Way out past the farthest Right</i></p>
<p class="poem3"><i>On a celestial trip.</i></p>
<p class="poem3" style="margin-top:20px;"><i>“Whither are you fellows hurled?”</i></p>
<p class="poem3"><i>The moon asked, out of the blue.</i></p>
<p class="poem3"><i>“Far away from the, quote, Third World,</i></p>
<p class="poem3"><i>As well as worlds One and Two.</i></p>
<p class="poem3"><i>No time to chat with you,”</i></p>
<p class="poem3"><i>Said Reagan,</i></p>
<p class="poem3"><i>Begin,</i></p>
<p class="poem3"><i>And God.</i></p>
<p class="poem3" style="margin-top:20px;"><i>The old moon sighed and took off, too—</i></p>
<p class="poem3"><i>He guessed what had gone down.</i></p>
<p class="poem3"><i>He told the stars, “If I were you,</i></p>
<p class="poem3"><i>I would not hang aroun’.”</i></p>
<p class="poem3"><i>So moon and stars and Holy Three</i></p>
<p class="poem3"><i>Distanced themselves from the globe—</i></p>
<p class="poem3"><i>And the sun cried, “How about me?”</i></p>
<p class="poem3"><i>“Join the trip (this one’s no probe)</i></p>
<p class="poem3"><i>If you’re a good xenophobe,”</i></p>
<p class="poem3"><i>Said Reagan,</i></p>
<p class="poem3"><i>Begin,</i></p>
<p class="poem3"><i>And God.</i></p>
<p class="noind" style="margin-top:20px;">So close your eyes while Frankie sings:</p>
<p class="poem3" style="margin-top:20px;"><i>Things are simpler today.</i></p>
<p class="poem3"><i>At any moment worrisome things</i></p>
<p class="poem3"><i>Will be nuclearized away.</i></p>
<p class="poem3"><i>And you’ll get to heaven, at least you may,</i></p>
<p class="poem3"><i>With Reagan,</i></p>
<p class="poem3"><i>Begin,</i></p>
<p class="poem3"><i>And God.</i></p>
<p class="noind" style="margin-top:20px;">(<i>Note:</i> As is often the case in poetry, a certain amount of realism has been sacrificed here to exigencies of the verse form. And vice versa.) You are not going to tell me that Jerry Zipkin won’t be on that ship, not after all he’s put himself through; and there is bound to be a berth for—but I can’t bring myself to write the man’s name, except just this once, for purposes of illustration—Edwin A. Meese III.</p>
<p class="poem3" style="margin-top:20px;"><i>E-D-W!</i></p>
<p class="poem3"><i>I-N-A!</i></p>
<p class="poem3"><i>M-E-E-S-E!</i></p>
<p class="poem3" style="margin-top:20px;"><i>Edwin Meese! Edwin Meese!</i></p>
<p class="poem3"><i>Forever let us hold his banner high!</i></p>
<p class="noind" style="margin-top:20px;">How can more than twelve or fourteen people in this entire nation have voted for a man who made no bones about having an aide named Edwin Meese? <i>III</i>!</p>
<p class="ind">Why is it that so grotesquely named a person’s closeness to the Last Big Holocaust button does not inflame all those people who thought “Jimmih” and “Rose-a-lyn” and “Jerdan” were ludicrous names? <i>Meese</i>. The man’s name is <i>Meese</i>. Edwin is bad enough. I have known some Edwins from Georgia, but never a Meese, by God!</p>
<p class="ind">Excuse me. I have gotten ethnic, after starting out so cosmic. But then, I ask you: what is less sublime than either religious bombing (<i>sorry; forget I said anything</i>) or politics that is deemed centrist because it is just to the left of a jackleg preacher?</p>
</a>
</div>
</div>
</template>
<script>

export default {
  name: 'chapter',
  data() {
    return {}
    },
      components: {
    }
  }
</script>



// WEBPACK FOOTER //
// 10-chap6.vue?42c57431